import React from 'react'
import { firestore } from '../firebase/firebase-utils'
import { FaSearch } from 'react-icons/fa'

const KeywordsList = (props) => {
    const [List, setList] = React.useState([])

    React.useEffect(() => {
        firestore.collection("queries").onSnapshot((querySnapshot) => {
            var query = querySnapshot.docs.map(doc => {
                return {
                    ...doc.data(),
                    docid: doc.id,
                }
            });

            // quering
            query = query.map((item) => (
                item.keys
            ));

            var list = [];
            if (query) {
                query.map((item) => (
                    item.map((key) => (
                        list.push(key)
                    ))
                ));
            }

            var arrList = [...new Set(list)]
            // iterations count for each number
            var irrCount = [];

            arrList.forEach((item) => {
                var count = list.reduce((acc, elem) => {
                    return item === elem ? acc + 1 : acc
                }, 0)
                irrCount.push({ key: item, count: count })
            })

            irrCount = irrCount.sort((a, b) => {
                return b.count - a.count
            })
            setList(irrCount)
        });
    }, [props]);

    const handleClick = () => {
        if (document.getElementById("keyword1").value !== '') {
            props.callBackFunction(document.getElementById("keyword1").value);
            document.getElementById("keyword1").value = '';
        } else if (document.getElementById("keyword2").value !== '') {
            props.callBackFunction(document.getElementById("keyword2").value);
            document.getElementById("keyword2").value = '';
        }
    }

    return (
        props.topKeys ?
            <div className="FloatingDiv">
                <div style={{ display: 'flex' }}>
                    <input list="keywordsList1" name="keyword" className="keyword" id="keyword1" placeholder="search a keyword..." />
                    <p style={{ margin: '10px', cursor: 'pointer' }} onClick={handleClick}><FaSearch /></p>
                    <datalist id="keywordsList1">
                        {List.map((ele) => (
                            <option key={ele.key}>{ele.key}</option>
                        ))}
                    </datalist>
                </div>
                {List.slice(0, 10).map((ele) => (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }} key={ele.key}><h6 onClick={(e) => props.callBackFunction(e.target.innerText)}>{ele.key}</h6><h6>{ele.count}</h6></div>
                ))}
            </div>
            :
            <div style={{ display: 'flex' }}>
                <input list="keywordsList2" name="keyword" className="keyword" id="keyword2" placeholder="search a keyword..." />
                <p style={{ margin: '10px', cursor: 'pointer' }} onClick={handleClick}><FaSearch /></p>
                <datalist id="keywordsList2">
                    {List.map((ele) => (
                        <option key={ele.key}>{ele.key}</option>
                    ))}
                </datalist>
            </div>
    )
}

export default KeywordsList
